import React, {useEffect, useState, useContext} from 'react'


const selectedTypeContext = React.createContext();
const selectedTypeToggleContext = React.createContext();

const editorTypeRightContext = React.createContext();
const editorTypeRightToggleContext = React.createContext();



export function useSelectedTypeContext() {
    return useContext(selectedTypeContext);
}

export function useSelectedTypeToggleContext() {
    return useContext(selectedTypeToggleContext);
}

export function useEditorTypeRightContext() {
    return useContext(editorTypeRightContext);
}

export function useEditorTypeRightToggleContext() {
    return useContext(editorTypeRightToggleContext);
}

const SelectedTypeProvider = ({children}) => {
    const [selectedType, setSelectedType] = useState("2D");
    const [ editorTypeRight, setEditorTypeRight ] = useState({type: null, data: null});



    useEffect(() => {
        console.log("selectedTypeedee", selectedType)
    }, [selectedType]);
    return (
        <selectedTypeContext.Provider value={selectedType}>
            <selectedTypeToggleContext.Provider value={setSelectedType}>

                <editorTypeRightContext.Provider value={editorTypeRight}>
                    <editorTypeRightToggleContext.Provider value={setEditorTypeRight}>

                        {children}
                    </editorTypeRightToggleContext.Provider>
                </editorTypeRightContext.Provider>

            </selectedTypeToggleContext.Provider>
        </selectedTypeContext.Provider>
    )
}
export default SelectedTypeProvider
